import { useEffect } from 'react';
import { usePostHog } from '@posthog/react';
import { useAuthStore } from '@stores/authStore';
import { setGaUserId } from '@lib/analytics';

export function PostHogUserSync() {
  const posthog = usePostHog();
  const user = useAuthStore((state) => state.user);

  useEffect(() => {
    // GA4: sync user_id on login/restore, clear on logout (channel attribution).
    setGaUserId(user ? String(user.id) : null);

    if (!posthog) return;
    if (user) {
      posthog.identify(user.id, {
        email: user.email,
        name: `${user.firstName} ${user.lastName}`.trim(),
      });
    } else {
      posthog.reset();
    }
  }, [posthog, user?.id, user?.email, user?.firstName, user?.lastName]);

  return null;
}
